module.exports = __webpack_public_path__ + "img/success.8ce25ede.png";